const localizers = {
  'loading.msg': () => `Ladevorgang...`,
  'logon.message.msg': () => `Authentifizierung erforderlich. Geben Sie eine gültige Benutzer-ID und ein gültiges Passwort ein.`,
  'logon.button.msg': () => `Anmeldung...`,
  'SASServer.logonError.msg': () => `Die Anmeldung am Server ist nicht möglich.`,
  'SASServer.genericError.msg': () => `Der Server ist nicht erreichbar.`,
}
export default localizers;
